module.exports = __webpack_public_path__ + "img/count_down_10.352624e0.webp";